import api from './api';

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append('image', file);
  const res = await api.post('/upload', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.url; // '/uploads/filename.jpg'
};

export const uploadImages = async (files) => {
  if (!files.length) return [];
  const fd = new FormData();
  Array.from(files).forEach(f => fd.append('images', f));
  const res = await api.post('/upload/multiple', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.urls;
};
